type OtpauthLabel = {
  issuer: string;
  account: string;
};

/**
 * The issuer and account an authenticator app will show for the credential.
 * They are read back out of the otpauth URI rather than from the signed-in
 * user, because forced enrolment runs mid-authentication, when no user is
 * loaded yet, and the issuer differs per environment.
 */
export const parseOtpauthLabel = (otpauthURI: string): OtpauthLabel => {
  try {
    const url = new URL(otpauthURI);
    const label = decodeURIComponent(url.pathname.replace(/^\//, ''));
    const issuerSeparatorIndex = label.indexOf(':');

    if (issuerSeparatorIndex === -1) {
      return { issuer: url.searchParams.get('issuer') ?? '', account: label };
    }

    return {
      issuer:
        url.searchParams.get('issuer') ?? label.slice(0, issuerSeparatorIndex),
      account: label.slice(issuerSeparatorIndex + 1),
    };
  } catch {
    return { issuer: '', account: '' };
  }
};
